// @ts-nocheck
import React, { useState } from 'react'
import { FileUploader } from '@aws-amplify/ui-react-storage';
import '@aws-amplify/ui-react/styles.css';
import { FiCheckCircle, FiAlertCircle } from 'react-icons/fi';
import { PageContainer, PageHeader } from "../components/AssetBreadCrumb";

const MAX_FILE_COUNT = 6;

// Everything on this list is a fact about how the uploader below is configured, so the panel can't drift from the behaviour it describes.
const UPLOAD_NOTES = [
  `Up to ${MAX_FILE_COUNT} files can be uploaded at one time.`,
  'Files are not uploaded until you click "Upload".',
  "Files are stored on the user level, not organization.",
];

const UploadPage = () => {
  const [errorMessage, setErrorMessage] = useState('')
  const [successMessage, setSuccessMessage] =useState('')

  const handleUploadStart = () => {
    setSuccessMessage("")
    setErrorMessage("")
  }

  const handleErrorMessage = (error) => {
    console.log("error", error)
    setErrorMessage(`Error Uploading files`)
  }

  const handleSuccessfullUpload = (file) => {
    console.log("success", file)
    setSuccessMessage("Successfully Uploaded")
  }

  // One slot for both outcomes — they are mutually exclusive, and a reserved empty div just pushed the panel's own padding around.
  const status = successMessage
    ? { tone: "success", text: successMessage, Icon: FiCheckCircle }
    : errorMessage
    ? { tone: "error", text: errorMessage, Icon: FiAlertCircle }
    : null;

  return (
    <PageContainer>
      <PageHeader
        eyebrow="Data"
        title="Upload Files"
      />

      {/* The uploader carries the page, so it takes the wide column; the notes ride beside it on lg and stack under it below that. Default stretch keeps the two panels the same height. */}
      <div className="grid gap-5 lg:grid-cols-[minmax(0,1fr)_320px]">
        <div className="eai-panel">
          <h2 className="eai-panel-title">Secure upload</h2>
          <p className="eai-description-sm mb-5 mt-1">
            Drop your files below, then upload them when the list looks right.
          </p>

          <div className="eai-file-uploader">
            <FileUploader
              autoUpload={false}
              path={({ identityId }) => `private/${identityId}/uploads/`}
              maxFileCount={MAX_FILE_COUNT}
              onUploadError={(err) => handleErrorMessage(err)}
              onUploadStart={() => handleUploadStart()}
              onUploadSuccess={(file) => handleSuccessfullUpload(file)}
              onFileRemove={() => handleUploadStart()}
              isResumable
            />
          </div>

          {status && (
            <div
              role="status"
              className={`font-inter mt-4 flex items-start gap-2 rounded-md border px-3 py-2 text-eai-body-sm ${
                status.tone === "success"
                  ? "border-eai-success-border bg-eai-success-surface-soft text-eai-success-text"
                  : "border-eai-danger-border bg-eai-danger-surface text-eai-danger-text"
              }`}
            >
              <status.Icon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
              <span>{status.text}</span>
            </div>
          )}
        </div>

        <aside className="eai-panel">
          <h2 className="eai-panel-title">Before you upload</h2>
          <ul className="mt-3 space-y-3">
            {UPLOAD_NOTES.map((note) => (
              <li key={note} className="flex items-start gap-2.5">
                <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-eai-cta-primary" />
                <span className="eai-description-sm">{note}</span>
              </li>
            ))}
          </ul>
        </aside>
      </div>
    </PageContainer>
  )
}

export default UploadPage
